import { useMemo } from "react";

import { Map, PermCameraMic } from "@mui/icons-material";
import AssessmentOutlined from "@mui/icons-material/AssessmentOutlined";
import CloudDownloadOutlined from "@mui/icons-material/CloudDownloadOutlined";
import ReceiptLongOutlined from "@mui/icons-material/ReceiptLongOutlined";
import { SvgIcon, useTheme } from "@mui/material";

const SvgIconWrapper = (props) => {
  const { sx, color, children, ...rest } = props;
  const theme = useTheme();

  const memoizedColor = useMemo(() => {
    if (!color) {
      return theme.palette.mode === "dark" ? theme.palette.text.primary : "black";
    } else {
      return color;
    }
  }, [color, theme.palette.mode]);

  rest.htmlColor = !color ? (theme.palette.mode === "dark" ? theme.palette.text.primary : "black") : undefined;
  rest.color = memoizedColor;
  rest.sx = { ...sx, fill: "none" };
  return <SvgIcon {...rest}>{children}</SvgIcon>;
};

export function FarmVaultIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12.37 2.14984L21.37 5.74982C21.72 5.88982 22 6.30981 22 6.67981V9.99982C22 10.5498 21.55 10.9998 21 10.9998H3C2.45 10.9998 2 10.5498 2 9.99982V6.67981C2 6.30981 2.28 5.88982 2.63 5.74982L11.63 2.14984C11.83 2.06984 12.17 2.06984 12.37 2.14984Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19V22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 18V11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 18V11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18V11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 18V11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 18V11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 22H23"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.5C12.8284 8.5 13.5 7.82843 13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function CloudVaultIcon(props) {
  return <CloudDownloadOutlined {...props} sx={{ ...props?.sx, color: "#00a8e8" }} />;
}

export function CropIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 28 28">
      <path
        d="M5.24992 25.6668C5.24234 20.2184 4.26032 16.2777 2.33325 9.62516C6.70825 12.5418 9.72124 14.3155 10.3541 25.6668C10.9373 16.7356 10.0519 11.6774 6.70825 2.3335C14.8571 7.70023 16.6574 12.5487 16.9166 25.6668C17.6746 17.6877 18.6824 13.7147 25.6666 11.0835C22.7499 17.646 22.6301 20.6631 22.7499 25.6668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function FarmIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 28 28">
      <path
        d="M9.33331 16.3333V5.24992C9.33331 4.47637 9.02602 3.7345 8.47904 3.18752C7.93206 2.64054 7.19019 2.33325 6.41665 2.33325C5.6431 2.33325 4.90123 2.64054 4.35425 3.18752C3.80727 3.7345 3.49998 4.47637 3.49998 5.24992V16.3333M9.33331 9.33325L16.3333 3.49992L25.6666 10.4999M23.3333 4.66659V16.3333M14 16.3333H18.6666V11.6666H14V16.3333ZM14 16.3333L8.16665 25.6666M2.33331 16.3333H25.6666M2.33331 25.6666L8.16665 16.3333M25.6666 25.6666H14L19.8333 16.3333M17.5 20.9999H25.6666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function FarmChipIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 26 26">
      <path
        className="farm-icon-background"
        d="M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13Z"
        fill="currentColor"
      />
      <path
        className="farm-icon-lines"
        d="M10 14.5V7.375C10 6.87772 9.80246 6.40081 9.45083 6.04917C9.09919 5.69754 8.62228 5.5 8.125 5.5C7.62772 5.5 7.15081 5.69754 6.79917 6.04917C6.44754 6.40081 6.25 6.87772 6.25 7.375V14.5M10 10L14.5 6.25L20.5 10.75M19 7V14.5M13 14.5H16V11.5H13V14.5ZM13 14.5L9.25 20.5M5.5 14.5H20.5M5.5 20.5L9.25 14.5M20.5 20.5H13L16.75 14.5M15.25 17.5H20.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function FarmCountyIcon(props) {
  return (
    <SvgIcon {...props} sx={{ ...props?.sx, color: "green !important" }} viewBox="0 0 512 512">
      <path d="M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z" />
    </SvgIcon>
  );
}

export const CropFieldIcon = (props) => {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 2L13.95 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.53 12.22L2 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
};

export function BudgetIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019C14.4719 16.6598 15.3419 15.7498 15.3419 14.6298C15.3419 13.4098 14.8119 12.9798 14.0219 12.6998L9.99187 11.2998C9.20187 11.0198 8.67188 10.5898 8.67188 9.36984C8.67188 8.24984 9.54187 7.33984 10.6119 7.33984H13.1219C14.3519 7.33984 15.3419 8.37984 15.3419 9.66984"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 6V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ArcPlcIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019C14.4719 16.6598 15.3419 15.7498 15.3419 14.6298C15.3419 13.4098 14.8119 12.9798 14.0219 12.6998L9.99187 11.2998C9.20187 11.0198 8.67188 10.5898 8.67188 9.36984C8.67188 8.24984 9.54187 7.33984 10.6119 7.33984H13.1219C14.3519 7.33984 15.3419 8.37984 15.3419 9.66984"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 6V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H15C20 2 22 4 22 9V15C22 20 20 22 15 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function InsuranceIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M10.49 2.23006L5.5 4.11006C4.35 4.54006 3.41 5.90006 3.41 7.12006V14.5501C3.41 15.7301 4.19 17.2801 5.14 17.9901L9.44 21.2001C10.85 22.2601 13.17 22.2601 14.58 21.2001L18.88 17.9901C19.83 17.2801 20.61 15.7301 20.61 14.5501V7.12006C20.61 5.89006 19.67 4.53006 18.52 4.10006L13.53 2.23006C12.68 1.92006 11.32 1.92006 10.49 2.23006Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0052 11.3047H8.9948"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.37028V14.3807"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function FinancialIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path d="M3 22H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M5.59998 8.37988H4C3.45 8.37988 3 8.82988 3 9.37988V17.9999C3 18.5499 3.45 18.9999 4 18.9999H5.59998C6.14998 18.9999 6.59998 18.5499 6.59998 17.9999V9.37988C6.59998 8.82988 6.14998 8.37988 5.59998 8.37988Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8 5.18994H11.2C10.65 5.18994 10.2 5.63994 10.2 6.18994V17.9999C10.2 18.5499 10.65 18.9999 11.2 18.9999H12.8C13.35 18.9999 13.8 18.5499 13.8 17.9999V6.18994C13.8 5.63994 13.35 5.18994 12.8 5.18994Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 2H18.4C17.85 2 17.4 2.45 17.4 3V18C17.4 18.55 17.85 19 18.4 19H20C20.55 19 21 18.55 21 18V3C21 2.45 20.55 2 20 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function EquipmentIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12.0082 10.7028H18.5231C19.2243 10.7028 19.8969 10.9874 20.3928 11.4939C20.8887 12.0005 21.1673 12.6876 21.1673 13.404V13.8252"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3388 18.1964H11.3838"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0041 7.37231V10.7029"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6694 10.7026V8.41284"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7196 6.1228H16.7458C16.5436 6.1228 16.3796 6.27761 16.3796 6.46857V7.02601C16.3796 7.21697 16.5436 7.37177 16.7458 7.37177H18.7196C18.9218 7.37177 19.0857 7.21697 19.0857 7.02601V6.46857C19.0857 6.27761 18.9218 6.1228 18.7196 6.1228Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6694 20.4855C20.5089 20.4855 22 18.9943 22 17.1549C22 15.3155 20.5089 13.8243 18.6694 13.8243C16.83 13.8243 15.3389 15.3155 15.3389 17.1549C15.3389 18.9943 16.83 20.4855 18.6694 20.4855Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5653 18.4044C19.3126 18.4044 19.9183 17.8452 19.9183 17.1555C19.9183 16.4657 19.3126 15.9065 18.5653 15.9065C17.818 15.9065 17.2122 16.4657 17.2122 17.1555C17.2122 17.8452 17.818 18.4044 18.5653 18.4044Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.18713 20.1873C11.358 19.2881 12.3889 16.7993 11.4897 14.6284C10.5905 12.4575 8.10167 11.4266 5.93077 12.3258C3.75987 13.225 2.72896 15.7138 3.62818 17.8847C4.5274 20.0557 7.01622 21.0866 9.18713 20.1873Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1126 17.9881C13.5419 16.8051 13.5804 15.5166 13.2225 14.3103C12.8646 13.104 12.1291 12.043 11.123 11.2818C10.1169 10.5207 8.89283 10.0992 7.62924 10.0788C6.36564 10.0584 5.12852 10.4401 4.09814 11.1684L4.9036 12.3327"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.78039 16.622C9.97859 15.401 9.14943 14.2505 7.92841 14.0523C6.70739 13.8541 5.55689 14.6832 5.35869 15.9043C5.16049 17.1253 5.98965 18.2758 7.21067 18.474C8.43168 18.6722 9.58219 17.843 9.78039 16.622Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6735 5.70605L15.1306 10.7019"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.55524 9.66111L6.17972 5.70605"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5634 3.00024H5.6653C5.37458 3.00024 5.13892 3.23617 5.13892 3.5272V4.34673C5.13892 4.63776 5.37458 4.87369 5.6653 4.87369H13.5634C13.8542 4.87369 14.0898 4.63776 14.0898 4.34673V3.5272C14.0898 3.23617 13.8542 3.00024 13.5634 3.00024Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.71844 4.87341V10.4938"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function FinancialDocumentsIcon(props) {
  return <ReceiptLongOutlined sx={{ ...props?.sx, color: "#00a8e8 !important" }} {...props} />;
}

export function LoanOriginationIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M6.73 19.7C7.55 18.82 8.8 18.89 9.52 19.85L10.53 21.2C11.34 22.27 12.65 22.27 13.46 21.2L14.47 19.85C15.19 18.89 16.44 18.82 17.26 19.7C19.04 21.6 20.49 20.97 20.49 18.31V7.04C20.5 3.01 19.56 2 15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.97 4.96 21.59 6.73 19.7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 13L15 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14.9945 13H15.0035"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99451 7.5H9.00349"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function MemberManagementIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M18 7.16C17.94 7.15 17.87 7.15 17.81 7.16C16.43 7.11 15.33 5.98 15.33 4.58C15.33 3.15 16.48 2 17.91 2C19.34 2 20.49 3.16 20.49 4.58C20.48 5.98 19.38 7.11 18 7.16Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.97 14.4402C18.34 14.6702 19.85 14.4302 20.91 13.7202C22.32 12.7802 22.32 11.2402 20.91 10.3002C19.84 9.59016 18.31 9.35016 16.94 9.59016"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.97 7.16C6.03 7.15 6.1 7.15 6.16 7.16C7.54 7.11 8.64 5.98 8.64 4.58C8.64 3.15 7.49 2 6.06 2C4.63 2 3.48 3.16 3.48 4.58C3.49 5.98 4.59 7.11 5.97 7.16Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 14.4402C5.63 14.6702 4.12 14.4302 3.06 13.7202C1.65 12.7802 1.65 11.2402 3.06 10.3002C4.13 9.59016 5.66 9.35016 7.03 9.59016"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.6302C11.94 14.6202 11.87 14.6202 11.81 14.6302C10.43 14.5802 9.33 13.4502 9.33 12.0502C9.33 10.6202 10.48 9.47021 11.91 9.47021C13.34 9.47021 14.49 10.6302 14.49 12.0502C14.48 13.4502 13.38 14.5902 12 14.6302Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09 17.7804C7.68 18.7204 7.68 20.2603 9.09 21.2003C10.69 22.2703 13.31 22.2703 14.91 21.2003C16.32 20.2603 16.32 18.7204 14.91 17.7804C13.32 16.7204 10.69 16.7204 9.09 17.7804Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function SecurityIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M10.49 2.23006L5.5 4.10005C4.35 4.53005 3.41 5.89004 3.41 7.12004V14.55C3.41 15.73 4.19001 17.28 5.14001 17.99L9.44 21.2001C10.85 22.2601 13.17 22.2601 14.58 21.2001L18.88 17.99C19.83 17.28 20.61 15.73 20.61 14.55V7.12004C20.61 5.89004 19.67 4.53005 18.52 4.10005L13.53 2.23006C12.68 1.92006 11.32 1.92006 10.49 2.23006Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.9199C11.96 10.9199 11.91 10.9199 11.87 10.9199C10.93 10.8899 10.18 10.1099 10.18 9.15991C10.18 8.18991 10.97 7.3999 11.94 7.3999C12.91 7.3999 13.7 8.18991 13.7 9.15991C13.69 10.1199 12.94 10.8899 12 10.9199Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.01 13.7199C9.05001 14.3599 9.05001 15.4099 10.01 16.0498C11.1 16.7799 12.89 16.7799 13.98 16.0498C14.94 15.4099 14.94 14.3599 13.98 13.7199C12.9 12.9899 11.11 12.9899 10.01 13.7199Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function FilePdfIcon(props) {
  return (
    <SvgIcon {...props} sx={{ ...props?.sx, color: "green !important" }} viewBox="0 0 384 512">
      <path d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z" />
    </SvgIcon>
  );
}

export function FileExcelIcon(props) {
  return (
    <SvgIcon {...props} sx={{ ...props?.sx, color: "green !important" }} viewBox="0 0 384 512">
      <path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z" />
    </SvgIcon>
  );
}

export function MarketingIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M5.89999 17H18.09C19.99 17 20.99 16 20.99 14.1V2H2.98999V14.1C2.99999 16 3.99999 17 5.89999 17Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 2H22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 22L12 20V17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 22L12 20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 11L10.65 8.37C10.9 8.16 11.23 8.22 11.4 8.5L12.6 10.5C12.77 10.78 13.1 10.83 13.35 10.63L16.5 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function BrokerIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 18.2002C14.2091 18.2002 16 16.4093 16 14.2002C16 11.9911 14.2091 10.2002 12 10.2002C9.79086 10.2002 8 11.9911 8 14.2002C8 16.4093 9.79086 18.2002 12 18.2002Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.44 14.2998L11.09 14.9498C11.28 15.1398 11.59 15.1398 11.78 14.9598L13.56 13.3198"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 22H16C20.02 22 20.74 20.39 20.95 18.43L21.7 10.43C21.97 7.99 21.27 6 17 6H7C2.73 6 2.03 7.99 2.3 10.43L3.05 18.43C3.26 20.39 3.98 22 8 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6V5.2C8 3.43 8 2 11.2 2H12.8C16 2 16 3.43 16 5.2V6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.65 11C19.92 12.26 18 13.14 16.01 13.64"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.62 11.27C4.29 12.41 6.11 13.22 8 13.68"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ReportsIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M3 9H21C21.55 9 22 9.45 22 10V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V10C2 9.45 2.45 9 3 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.04 8.99994L15.4 5.99994C15.1 4.99994 14.2 4.09994 13.1 4.09994H10.9C9.8 4.09994 8.9 4.99994 8.6 5.99994L8 8.99994"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function CalculatorIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16 10V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.58576 17.4142L9.41418 14.5858"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 8H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 15H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 17.4142H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 8H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.58582 14.5858L9.41424 17.4142"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function SystemIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M6.44 2H17.55C21.11 2 22 2.89 22 6.44V12.77C22 16.33 21.11 17.21 17.56 17.21H6.44C2.89 17.22 2 16.33 2 12.78V6.44C2 2.89 2.89 2 6.44 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.2202V22.0002"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 13H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.5 22H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIconWrapper>
  );
}

export function ArrowLeftIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 26 26">
      <path
        d="M10.3675 6.42432L3.79163 13.0001L10.3675 19.576"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2083 13H3.97583"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ArrowRightIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 26 26">
      <path
        d="M15.6324 6.42407L22.2083 12.9999L15.6324 19.5757"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.79163 13H22.0241"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function AccountIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2101 15.74L15.67 19.2801C15.53 19.4201 15.4 19.68 15.37 19.87L15.18 21.22C15.11 21.71 15.45 22.05 15.94 21.98L17.29 21.79C17.48 21.76 17.75 21.63 17.88 21.49L21.42 17.95C22.03 17.34 22.32 16.63 21.42 15.73C20.53 14.84 19.8201 15.13 19.2101 15.74Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7001 16.25C19.0001 17.33 19.84 18.17 20.92 18.47"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.40991 22C3.40991 18.13 7.25994 15 11.9999 15C13.0399 15 14.0399 15.15 14.9699 15.43"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function LogoutIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 12H14.88" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.65 8.6499L16 11.9999L12.65 15.3499"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function PersonIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function AccountLogoutIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.40991 22C3.40991 18.13 7.25994 15 11.9999 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0792 15.4651C16.2213 13.8151 17.0692 13.1414 18.9255 13.1414H18.9851C21.0338 13.1414 21.8542 13.9618 21.8542 16.0105V18.9989C21.8542 21.0476 21.0338 21.868 18.9851 21.868H18.9255C17.083 21.868 16.2351 21.2034 16.0838 19.5809"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9166 17.5H18.82"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.798 15.9646L19.3334 17.5L17.798 19.0354"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ArrowDownIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 18 18">
      <path
        d="M14.9401 6.7124L10.0501 11.6024C9.47256 12.1799 8.52756 12.1799 7.95006 11.6024L3.06006 6.7124"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ArrowUpIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 18 18">
      <path
        d="M14.9401 11.2875L10.0501 6.39748C9.47256 5.81998 8.52756 5.81998 7.95006 6.39748L3.06006 11.2875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function MoreIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </SvgIconWrapper>
  );
}

export function MoreIconFilled(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 18 18">
      <path
        d="M3.75 7.5C2.925 7.5 2.25 8.175 2.25 9C2.25 9.825 2.925 10.5 3.75 10.5C4.575 10.5 5.25 9.825 5.25 9C5.25 8.175 4.575 7.5 3.75 7.5Z"
        fill="currentColor"
      />
      <path
        d="M14.25 7.5C13.425 7.5 12.75 8.175 12.75 9C12.75 9.825 13.425 10.5 14.25 10.5C15.075 10.5 15.75 9.825 15.75 9C15.75 8.175 15.075 7.5 14.25 7.5Z"
        fill="currentColor"
      />
      <path
        d="M9 7.5C8.175 7.5 7.5 8.175 7.5 9C7.5 9.825 8.175 10.5 9 10.5C9.825 10.5 10.5 9.825 10.5 9C10.5 8.175 9.825 7.5 9 7.5Z"
        fill="currentColor"
      />
    </SvgIconWrapper>
  );
}

export function HeyTilleyIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 28 28">
      <path
        className="big-star"
        d="M20.4815 11.4076L18.6745 10.7387C16.3048 9.86239 15.12 9.42424 14.2554 8.55961C13.3908 7.69498 12.9526 6.51016 12.0763 4.14053L11.4074 2.3335L10.7385 4.14053C9.86224 6.51016 9.42279 7.69498 8.55946 8.55961C7.69613 9.42424 6.51002 9.86239 4.14039 10.7387L2.33335 11.4076L4.14039 12.0765C6.51002 12.9528 7.69483 13.3922 8.55946 14.2555C9.42409 15.1189 9.86224 16.305 10.7385 18.6746L11.4074 20.4816L12.0763 18.6746C12.9526 16.305 13.3908 15.1202 14.2554 14.2555C15.12 13.3909 16.3048 12.9528 18.6745 12.0765L20.4815 11.4076Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="small-star"
        d="M25.6667 21.7779L24.8928 21.4915C23.8765 21.1155 23.3684 20.9276 22.9989 20.5581C22.6282 20.1874 22.4402 19.6792 22.0656 18.6629L21.7778 17.8891L21.4913 18.6642C21.1154 19.6792 20.9274 20.1874 20.558 20.5568C20.1872 20.9276 19.6791 21.1155 18.6628 21.4902L17.8889 21.7779L18.6628 22.0644C19.6791 22.4404 20.1872 22.6283 20.5567 22.9978C20.9274 23.3685 21.1154 23.8766 21.49 24.8929L21.7778 25.6668L22.0643 24.8916C22.4402 23.8766 22.6282 23.3685 22.9976 22.9991C23.3684 22.6283 23.8765 22.4404 24.8928 22.0657L25.6667 21.7779Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function CloseIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M3.99994 20L20 3.99993"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 20.0001L3.99994 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function MicrophoneIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 15.5C14.21 15.5 16 13.71 16 11.5V6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6V11.5C8 13.71 9.79 15.5 12 15.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.3501 9.65002V11.35C4.3501 15.57 7.7801 19 12.0001 19C16.2201 19 19.6501 15.57 19.6501 11.35V9.65002"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2 8.54995C11.73 8.40995 12.28 8.40995 12.81 8.54995"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 19V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIconWrapper>
  );
}

export function EditIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M13.26 3.59997L5.04997 12.29C4.73997 12.62 4.43997 13.27 4.37997 13.72L4.00997 16.96C3.87997 18.13 4.71997 18.93 5.87997 18.73L9.09997 18.18C9.54997 18.1 10.18 17.77 10.49 17.43L18.7 8.73997C20.12 7.23997 20.76 5.52997 18.55 3.43997C16.35 1.36997 14.68 2.09997 13.26 3.59997Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.89 5.05005C12.32 7.81005 14.56 9.92005 17.34 10.2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function EditIconUnderLine(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M13.2599 3.60022L5.04985 12.2902C4.73985 12.6202 4.43985 13.2702 4.37985 13.7202L4.00985 16.9602C3.87985 18.1302 4.71985 18.9302 5.87985 18.7302L9.09985 18.1802C9.54985 18.1002 10.1799 17.7702 10.4899 17.4302L18.6999 8.74022C20.1199 7.24022 20.7599 5.53022 18.5499 3.44022C16.3499 1.37022 14.6799 2.10022 13.2599 3.60022Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8901 5.0498C12.3201 7.8098 14.5601 9.9198 17.3401 10.1998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 22H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIconWrapper>
  );
}

export function SendIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M9.51002 4.22989L18.07 8.50989C21.91 10.4299 21.91 13.5699 18.07 15.4899L9.51002 19.7699C3.75002 22.6499 1.40002 20.2899 4.28002 14.5399L5.15002 12.8099C5.37002 12.3699 5.37002 11.6399 5.15002 11.1999L4.28002 9.45989C1.40002 3.70989 3.76002 1.34989 9.51002 4.22989Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44006 12H10.8401"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function DeleteIcon(props) {
  return (
    <SvgIconWrapper {...props} aria-label="delete" viewBox="0 0 18 19">
      <path
        d="M16.25 4.48486C13.7525 4.23736 11.24 4.10986 8.735 4.10986C7.25 4.10986 5.765 4.18486 4.28 4.33486L2.75 4.48486"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 3.7275L7.04 2.745C7.16 2.0325 7.25 1.5 8.5175 1.5H10.4825C11.75 1.5 11.8475 2.0625 11.96 2.7525L12.125 3.7275"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6373 6.85498L14.1498 14.4075C14.0673 15.585 13.9998 16.5 11.9073 16.5H7.0923C4.9998 16.5 4.9323 15.585 4.8498 14.4075L4.3623 6.85498"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.24756 12.375H10.7451" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.625 9.375H11.375" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIconWrapper>
  );
}

export function PauseCircle(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M11.9697 22C17.4926 22 21.9697 17.5228 21.9697 12C21.9697 6.47715 17.4926 2 11.9697 2C6.44688 2 1.96973 6.47715 1.96973 12C1.96973 17.5228 6.44688 22 11.9697 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.72 14.53V9.47005C10.72 8.99005 10.52 8.80005 10.01 8.80005H8.71C8.2 8.80005 8 8.99005 8 9.47005V14.53C8 15.01 8.2 15.2 8.71 15.2H10C10.52 15.2 10.72 15.01 10.72 14.53Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 14.53V9.47005C16 8.99005 15.8 8.80005 15.29 8.80005H14C13.49 8.80005 13.29 8.99005 13.29 9.47005V14.53C13.29 15.01 13.49 15.2 14 15.2H15.29C15.8 15.2 16 15.01 16 14.53Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function PlayCircle(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M11.9702 22C17.4931 22 21.9702 17.5228 21.9702 12C21.9702 6.47715 17.4931 2 11.9702 2C6.44737 2 1.97021 6.47715 1.97021 12C1.97021 17.5228 6.44737 22 11.9702 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.74023 12.2299V10.5599C8.74023 8.47988 10.2102 7.62988 12.0102 8.66988L13.4602 9.50988L14.9102 10.3499C16.7102 11.3899 16.7102 13.0899 14.9102 14.1299L13.4602 14.9699L12.0102 15.8099C10.2102 16.8499 8.74023 15.9999 8.74023 13.9199V12.2299Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function SoundWaveIcon(props) {
  return (
    <SvgIconWrapper width="119" height="14" {...props} viewBox="0 0 119 14">
      <path
        d="M10.75 0C11.3021 0 11.7496 0.215956 11.75 0.482422V13.5176C11.7496 13.784 11.3021 14 10.75 14C10.1979 14 9.75038 13.784 9.75 13.5176V0.482422C9.75038 0.215956 10.1979 0 10.75 0ZM32.75 0C33.3021 0 33.7496 0.215956 33.75 0.482422V13.5176C33.7496 13.784 33.3021 14 32.75 14C32.1979 14 31.7504 13.784 31.75 13.5176V0.482422C31.7504 0.215956 32.1979 0 32.75 0ZM45.75 0C46.3021 0 46.7496 0.215956 46.75 0.482422V13.5176C46.7496 13.784 46.3021 14 45.75 14C45.1979 14 44.7504 13.784 44.75 13.5176V0.482422C44.7504 0.215956 45.1979 0 45.75 0ZM67.75 0C68.3021 0 68.7496 0.215956 68.75 0.482422V13.5176C68.7496 13.784 68.3021 14 67.75 14C67.1979 14 66.7504 13.784 66.75 13.5176V0.482422C66.7504 0.215956 67.1979 0 67.75 0ZM86.75 0C87.3021 0 87.7496 0.215956 87.75 0.482422V13.5176C87.7496 13.784 87.3021 14 86.75 14C86.1979 14 85.7504 13.784 85.75 13.5176V0.482422C85.7504 0.215956 86.1979 0 86.75 0ZM108.75 0C109.302 0 109.75 0.215956 109.75 0.482422V13.5176C109.75 13.784 109.302 14 108.75 14C108.198 14 107.75 13.784 107.75 13.5176V0.482422C107.75 0.215956 108.198 0 108.75 0ZM6.25 2.89648C6.80201 2.89648 7.24955 3.11247 7.25 3.37891V10.6211C7.24955 10.8875 6.80201 11.1035 6.25 11.1035C5.69799 11.1035 5.25045 10.8875 5.25 10.6211V3.37891C5.25045 3.11247 5.69799 2.89648 6.25 2.89648ZM19.75 2.89648C20.302 2.89648 20.7495 3.11247 20.75 3.37891V10.6211C20.7495 10.8875 20.302 11.1035 19.75 11.1035C19.198 11.1035 18.7505 10.8875 18.75 10.6211V3.37891C18.7505 3.11247 19.198 2.89648 19.75 2.89648ZM28.25 2.89648C28.802 2.89648 29.2495 3.11247 29.25 3.37891V10.6211C29.2495 10.8875 28.802 11.1035 28.25 11.1035C27.698 11.1035 27.2505 10.8875 27.25 10.6211V3.37891C27.2505 3.11247 27.698 2.89648 28.25 2.89648ZM41.25 2.89648C41.802 2.89648 42.2495 3.11247 42.25 3.37891V10.6211C42.2495 10.8875 41.802 11.1035 41.25 11.1035C40.698 11.1035 40.2505 10.8875 40.25 10.6211V3.37891C40.2505 3.11247 40.698 2.89648 41.25 2.89648ZM54.75 2.89648C55.302 2.89648 55.7495 3.11247 55.75 3.37891V10.6211C55.7495 10.8875 55.302 11.1035 54.75 11.1035C54.198 11.1035 53.7505 10.8875 53.75 10.6211V3.37891C53.7505 3.11247 54.198 2.89648 54.75 2.89648ZM63.25 2.89648C63.802 2.89648 64.2495 3.11247 64.25 3.37891V10.6211C64.2495 10.8875 63.802 11.1035 63.25 11.1035C62.698 11.1035 62.2505 10.8875 62.25 10.6211V3.37891C62.2505 3.11247 62.698 2.89648 63.25 2.89648ZM82.25 2.89648C82.802 2.89648 83.2495 3.11247 83.25 3.37891V10.6211C83.2495 10.8875 82.802 11.1035 82.25 11.1035C81.698 11.1035 81.2505 10.8875 81.25 10.6211V3.37891C81.2505 3.11247 81.698 2.89648 82.25 2.89648ZM95.75 2.89648C96.302 2.89648 96.7495 3.11247 96.75 3.37891V10.6211C96.7495 10.8875 96.302 11.1035 95.75 11.1035C95.198 11.1035 94.7505 10.8875 94.75 10.6211V3.37891C94.7505 3.11247 95.198 2.89648 95.75 2.89648ZM104.25 2.89648C104.802 2.89648 105.25 3.11247 105.25 3.37891V10.6211C105.25 10.8875 104.802 11.1035 104.25 11.1035C103.698 11.1035 103.25 10.8875 103.25 10.6211V3.37891C103.25 3.11247 103.698 2.89648 104.25 2.89648ZM117.25 2.89648C117.802 2.89648 118.25 3.11247 118.25 3.37891V10.6211C118.25 10.8875 117.802 11.1035 117.25 11.1035C116.698 11.1035 116.25 10.8875 116.25 10.6211V3.37891C116.25 3.11247 116.698 2.89648 117.25 2.89648ZM1.75 5.06934C2.30228 5.06934 2.75 5.28514 2.75 5.55176V8.44824C2.75 8.71486 2.30228 8.93066 1.75 8.93066C1.19772 8.93066 0.75 8.71486 0.75 8.44824V5.55176C0.75 5.28514 1.19772 5.06934 1.75 5.06934ZM15.25 5.06934C15.8023 5.06934 16.25 5.28514 16.25 5.55176V8.44824C16.25 8.71486 15.8023 8.93066 15.25 8.93066C14.6977 8.93066 14.25 8.71486 14.25 8.44824V5.55176C14.25 5.28514 14.6977 5.06934 15.25 5.06934ZM23.75 5.06934C24.3023 5.06934 24.75 5.28514 24.75 5.55176V8.44824C24.75 8.71486 24.3023 8.93066 23.75 8.93066C23.1977 8.93066 22.75 8.71486 22.75 8.44824V5.55176C22.75 5.28514 23.1977 5.06934 23.75 5.06934ZM36.75 5.06934C37.3023 5.06934 37.75 5.28514 37.75 5.55176V8.44824C37.75 8.71486 37.3023 8.93066 36.75 8.93066C36.1977 8.93066 35.75 8.71486 35.75 8.44824V5.55176C35.75 5.28514 36.1977 5.06934 36.75 5.06934ZM50.25 5.06934C50.8023 5.06934 51.25 5.28514 51.25 5.55176V8.44824C51.25 8.71486 50.8023 8.93066 50.25 8.93066C49.6977 8.93066 49.25 8.71486 49.25 8.44824V5.55176C49.25 5.28514 49.6977 5.06934 50.25 5.06934ZM58.75 5.06934C59.3023 5.06934 59.75 5.28514 59.75 5.55176V8.44824C59.75 8.71486 59.3023 8.93066 58.75 8.93066C58.1977 8.93066 57.75 8.71486 57.75 8.44824V5.55176C57.75 5.28514 58.1977 5.06934 58.75 5.06934ZM71.75 5.06934C72.3023 5.06934 72.75 5.28514 72.75 5.55176V8.44824C72.75 8.71486 72.3023 8.93066 71.75 8.93066C71.1977 8.93066 70.75 8.71486 70.75 8.44824V5.55176C70.75 5.28514 71.1977 5.06934 71.75 5.06934ZM77.75 5.06934C78.3023 5.06934 78.75 5.28514 78.75 5.55176V8.44824C78.75 8.71486 78.3023 8.93066 77.75 8.93066C77.1977 8.93066 76.75 8.71486 76.75 8.44824V5.55176C76.75 5.28514 77.1977 5.06934 77.75 5.06934ZM91.25 5.06934C91.8023 5.06934 92.25 5.28514 92.25 5.55176V8.44824C92.25 8.71486 91.8023 8.93066 91.25 8.93066C90.6977 8.93066 90.25 8.71486 90.25 8.44824V5.55176C90.25 5.28514 90.6977 5.06934 91.25 5.06934ZM99.75 5.06934C100.302 5.06934 100.75 5.28514 100.75 5.55176V8.44824C100.75 8.71486 100.302 8.93066 99.75 8.93066C99.1977 8.93066 98.75 8.71486 98.75 8.44824V5.55176C98.75 5.28514 99.1977 5.06934 99.75 5.06934ZM112.75 5.06934C113.302 5.06934 113.75 5.28514 113.75 5.55176V8.44824C113.75 8.71486 113.302 8.93066 112.75 8.93066C112.198 8.93066 111.75 8.71486 111.75 8.44824V5.55176C111.75 5.28514 112.198 5.06934 112.75 5.06934Z"
        fill="white"
      />
    </SvgIconWrapper>
  );
}

export function MinimizeWave(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M3 7.33333V10.6667M6 4.83333V13.1667M9 1.5V16.5M12 7.33333V10.6667M15 4.83333V13.1667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function CardViewIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M9 20H15C20 20 22 18.4 22 14.4V9.6C22 5.6 20 4 15 4H9C4 4 2 5.6 2 9.6V14.4C2 18.4 4 20 9 20Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function GridViewIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M19.9 13.5H4.1C2.6 13.5 2 14.14 2 15.73V19.77C2 21.36 2.6 22 4.1 22H19.9C21.4 22 22 21.36 22 19.77V15.73C22 14.14 21.4 13.5 19.9 13.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9 2H4.1C2.6 2 2 2.64 2 4.23V8.27C2 9.86 2.6 10.5 4.1 10.5H19.9C21.4 10.5 22 9.86 22 8.27V4.23C22 2.64 21.4 2 19.9 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function NavigateIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M14.4301 5.92999L20.5001 12L14.4301 18.07"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12H20.33"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function CreateCopyIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M22 11.1V6.9C22 3.4 20.6 2 17.1 2H12.9C9.4 2 8 3.4 8 6.9V8H11.1C14.6 8 16 9.4 16 12.9V16H17.1C20.6 16 22 14.6 22 11.1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17.1V12.9C16 9.4 14.6 8 11.1 8H6.9C3.4 8 2 9.4 2 12.9V17.1C2 20.6 3.4 22 6.9 22H11.1C14.6 22 16 20.6 16 17.1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 15H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 18V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIconWrapper>
  );
}

export function RefreshIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M9.11008 5.0799C9.98008 4.8199 10.9401 4.6499 12.0001 4.6499C16.7901 4.6499 20.6701 8.5299 20.6701 13.3199C20.6701 18.1099 16.7901 21.9899 12.0001 21.9899C7.21008 21.9899 3.33008 18.1099 3.33008 13.3199C3.33008 11.5399 3.87008 9.8799 4.79008 8.4999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.87012 5.32L10.7601 2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.87012 5.32007L11.2401 7.78007"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ArcPlcCardIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M22 9.00002V15C22 17.5 21.5 19.25 20.38 20.38L14 14L21.73 6.27002C21.91 7.06002 22 7.96002 22 9.00002Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.73 6.27L6.26999 21.73C3.25999 21.04 2 18.96 2 15V9C2 4 4 2 9 2H15C18.96 2 21.04 3.26 21.73 6.27Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.38 20.38C19.25 21.5 17.5 22 15 22H9.00003C7.96003 22 7.06002 21.91 6.27002 21.73L14 14L20.38 20.38Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.24002 7.97997C6.92002 5.04997 11.32 5.04997 12 7.97997C12.39 9.69997 11.31 11.16 10.36 12.06C9.67001 12.72 8.58003 12.72 7.88003 12.06C6.93003 11.16 5.84002 9.69997 6.24002 7.97997Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M9.0946 8.70001H9.10359"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function InfoIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9983 16L11.9983 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0037 8L11.9947 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ArcPlcCropIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M2.04806 8.6414L2.00168 7.07301C1.97257 6.07404 2.32215 5.10103 2.98027 4.34921L3.11383 4.19701C3.68395 3.54539 4.4791 3.13335 5.34 3.04346C6.21136 2.95131 7.04952 2.65844 7.78877 2.18781L8.09208 1.99477C8.23739 1.90181 8.4108 1.86304 8.58184 1.88527C8.74448 1.90627 8.89558 1.98059 9.01154 2.09661C9.1275 2.21263 9.20179 2.36382 9.22278 2.52654V2.5516C9.24304 2.7073 9.21281 2.86541 9.13652 3.00263L8.79518 3.61884C8.46198 4.22351 8.24194 4.88397 8.14589 5.56773L8.13196 5.66053C7.9977 6.5954 7.53345 7.45132 6.82318 8.07344L6.76011 8.12819C6.00892 8.78633 5.03668 9.13577 4.03862 9.10635L2.47011 9.05995C2.36015 9.05686 2.25556 9.01168 2.17791 8.93373C2.0991 8.85631 2.05269 8.7518 2.04806 8.6414Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6444 4.82116L20.6683 5.14216C20.7097 5.70047 20.8071 6.25333 20.9589 6.79264L21.2348 7.79293C21.3001 8.02755 21.2895 8.27651 21.2044 8.50484C21.1193 8.73317 20.964 8.92942 20.7603 9.06602C20.421 9.29391 20.1662 9.62499 20.0346 10.009L19.7053 10.9638C19.6834 11.0268 19.6482 11.0844 19.6018 11.1327C19.5554 11.181 19.4991 11.2189 19.4366 11.2437C19.3741 11.2686 19.307 11.2798 19.2397 11.2767C19.1724 11.2736 19.1066 11.2562 19.0467 11.2257L18.069 10.7265C17.7198 10.5483 17.323 10.4825 16.9341 10.5383H16.9065C16.6623 10.5731 16.4133 10.5312 16.1945 10.4187C15.9757 10.3061 15.7981 10.1285 15.6869 9.91081L15.0918 8.75411C14.918 8.41411 14.7126 8.09081 14.4783 7.78838L14.0433 7.22731C13.7583 6.85957 13.5513 6.43873 13.4347 5.99C13.3181 5.54128 13.2944 5.0739 13.3649 4.61588C13.4354 4.15787 13.5987 3.71864 13.8451 3.32452C14.0914 2.9304 14.4156 2.5895 14.7984 2.32226C15.2439 2.011 15.7571 1.80759 16.2967 1.72845L16.6646 1.67571C17.1375 1.60655 17.6197 1.63445 18.0812 1.75767C18.5427 1.8809 18.9736 2.0968 19.347 2.39191C19.7204 2.68703 20.0283 3.05503 20.2515 3.47298C20.4747 3.89093 20.6084 4.34986 20.6444 4.82116Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4131 10.3133C17.0687 9.89709 16.7927 9.43365 16.5948 8.9388C15.961 7.38368 16.1429 5.86733 17.0012 5.5519C17.8594 5.23648 19.0674 6.24179 19.7011 7.79691C19.9078 8.29179 20.033 8.81393 20.0723 9.34498"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4476 14.4738L11.9245 14.3826C12.2858 14.3131 12.6265 14.1651 12.9215 13.9494C13.2165 13.7337 13.4583 13.4559 13.629 13.1365L13.7678 12.8765C14.0142 12.4154 14.1015 11.8886 14.0167 11.3749C13.9319 10.8612 13.6796 10.3881 13.2974 10.0266C12.9718 9.71842 12.5657 9.50426 12.1238 9.40768C11.6819 9.3111 11.2213 9.33586 10.7929 9.47923L10.3858 9.61515C9.87031 9.7885 9.31048 9.7885 8.79496 9.61515L8.38795 9.47923C7.95948 9.33586 7.49891 9.3111 7.05699 9.40768C6.61508 9.50426 6.20895 9.71842 5.88335 10.0266C5.50122 10.3881 5.24888 10.8612 5.16409 11.3749C5.07931 11.8886 5.16662 12.4154 5.41298 12.8765L5.55176 13.1365C5.72251 13.4559 5.96432 13.7337 6.25933 13.9494C6.55434 14.1651 6.89503 14.3131 7.25626 14.3826L7.73316 14.4738C8.95957 14.7101 10.2212 14.7101 11.4476 14.4738Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5585 18.265C20.4667 20.1125 18.4891 20.9405 17.1405 20.1134C15.792 19.2863 15.5844 17.1179 16.6761 15.2695C17.7678 13.4211 21.3643 12.9642 21.3643 12.9642C21.3643 12.9642 22.6547 16.4175 21.5585 18.265Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.23062 16.6603C8.24406 16.4756 7.31602 16.6085 6.65862 17.0102C6.56294 16.9213 6.45323 16.8492 6.33403 16.7969C6.17516 16.7255 6.0028 16.69 5.82894 16.6927C5.65507 16.6954 5.48388 16.7363 5.32728 16.8127C5.17068 16.889 5.03243 16.9988 4.92215 17.1346C4.81187 17.2703 4.73221 17.4287 4.6887 17.5987C4.6452 17.7687 4.63889 17.9462 4.67024 18.1189C4.70159 18.2916 4.76982 18.4554 4.87021 18.5987C4.97059 18.7421 5.1007 18.8617 5.2515 18.9491C5.40229 19.0365 5.57015 19.0897 5.74337 19.105C5.95824 20.175 6.93199 21.2783 8.33457 21.9006C10.2885 22.7656 12.3457 22.3779 12.9291 21.0346C13.5124 19.6913 12.4015 17.8955 10.4476 17.0351C10.0566 16.8613 9.64697 16.7337 9.22696 16.6547"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ArcPlcBaseAcreIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path d="M22 15.0448V21.2825" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.9661 16.5505C13.903 16.1822 14.865 15.8851 15.8441 15.6617C17.6774 15.2458 19.5496 15.0389 21.4268 15.0449C21.6182 15.0449 21.8087 15.0449 22 15.0508"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6226 17.8411C18.2067 17.5518 19.8147 17.4078 21.426 17.4109C21.6176 17.4109 21.8084 17.4109 22 17.4173"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6226 20.2072C17.9714 19.9532 19.338 19.8093 20.7094 19.777"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.99622 14.3997V13.3242" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.99622 21.2828V14.3998" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21.9999 21.2827H15.5058H1.99622" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1.99622 13.3242C9.26352 13.5629 15.2845 16.8664 17.0528 21.2827"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.2868 15.6903C7.79353 16.5044 11.5333 18.5656 13.6113 21.2827"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.99622 18.0564C4.0792 18.5201 5.97495 19.2584 7.58865 20.2073"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1924 6.49183C16.4254 6.1934 16.7442 5.97588 17.1046 5.86943C17.465 5.76299 17.8492 5.77289 18.2038 5.89778C18.5584 6.02267 18.8659 6.25634 19.0836 6.56639C19.3013 6.87644 19.4185 7.2475 19.4188 7.6281V14.8302"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2679 15.2604V9.91414L15.8158 7.56142L12.6438 5.79626L9.47093 7.56142L8.01886 9.91414V14.3033"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6 14.7791V11.8188H14.6868V15.6905"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4676 9.86319C13.8718 9.45907 13.8718 8.80385 13.4677 8.39973C13.0635 7.99561 12.4083 7.99561 12.0042 8.39974C11.6001 8.80386 11.6001 9.45907 12.0042 9.8632C12.4083 10.2673 13.0635 10.2673 13.4676 9.86319Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.01885 9.88245L7.37357 10.9579" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.2679 9.88245L18.1283 10.9579" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.36224 3L4.57734 6.87169" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.58871 7.73171L4.57739 6.87134" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.99622 8.37699L4.57734 6.87134" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.57739 6.87134V13.3242" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIconWrapper>
  );
}
export function WarningIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path d="M12 9V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.9999 21.41H5.93993C2.46993 21.41 1.01993 18.93 2.69993 15.9L5.81993 10.28L8.75993 5.00003C10.5399 1.79003 13.4599 1.79003 15.2399 5.00003L18.1799 10.29L21.2999 15.91C22.9799 18.94 21.5199 21.42 18.0599 21.42H11.9999V21.41Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9946 17H12.0036"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}
export function VisibilityIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M15.58 12C15.58 13.98 13.98 15.58 12 15.58C10.02 15.58 8.42004 13.98 8.42004 12C8.42004 10.02 10.02 8.42004 12 8.42004C13.98 8.42004 15.58 10.02 15.58 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20.27C15.53 20.27 18.82 18.19 21.11 14.59C22.01 13.18 22.01 10.81 21.11 9.39997C18.82 5.79997 15.53 3.71997 12 3.71997C8.46997 3.71997 5.17997 5.79997 2.88997 9.39997C1.98997 10.81 1.98997 13.18 2.88997 14.59C5.17997 18.19 8.46997 20.27 12 20.27Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}
export function UserGrantEditIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0399 3.02001L8.15988 10.9C7.85988 11.2 7.55988 11.79 7.49988 12.22L7.06988 15.23C6.90988 16.32 7.67988 17.08 8.76988 16.93L11.7799 16.5C12.1999 16.44 12.7899 16.14 13.0999 15.84L20.9799 7.96001C22.3399 6.60001 22.9799 5.02001 20.9799 3.02001C18.9799 1.02001 17.3999 1.66001 16.0399 3.02001Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9099 4.14999C15.5799 6.53999 17.4499 8.40999 19.8499 9.08999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}
export function SelectedCheckboxIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M2 12L8.65882 19L22 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function TilleyIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M17.5556 9.77778L16.0067 9.20444C13.9756 8.45333 12.96 8.07778 12.2189 7.33667C11.4778 6.59556 11.1022 5.58 10.3511 3.54889L9.77778 2L9.20444 3.54889C8.45333 5.58 8.07667 6.59556 7.33667 7.33667C6.59667 8.07778 5.58 8.45333 3.54889 9.20444L2 9.77778L3.54889 10.3511C5.58 11.1022 6.59555 11.4789 7.33666 12.2189C8.07778 12.9589 8.45333 13.9756 9.20444 16.0067L9.77778 17.5556L10.3511 16.0067C11.1022 13.9756 11.4778 12.96 12.2189 12.2189C12.96 11.4778 13.9756 11.1022 16.0067 10.3511L17.5556 9.77778ZM22 18.6667L21.3367 18.4211C20.4656 18.0989 20.03 17.9378 19.7133 17.6211C19.3956 17.3033 19.2344 16.8678 18.9133 15.9967L18.6667 15.3333L18.4211 15.9978C18.0989 16.8678 17.9378 17.3033 17.6211 17.62C17.3033 17.9378 16.8678 18.0989 15.9967 18.42L15.3333 18.6667L15.9967 18.9122C16.8678 19.2344 17.3033 19.3956 17.62 19.7122C17.9378 20.03 18.0989 20.4656 18.42 21.3367L18.6667 22L18.9122 21.3356C19.2344 20.4656 19.3956 20.03 19.7122 19.7133C20.03 19.3956 20.4656 19.2344 21.3367 18.9133L22 18.6667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function SidebarIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M21.9697 15V9C21.9697 4 19.9697 2 14.9697 2H8.96973C3.96973 2 1.96973 4 1.96973 9V15C1.96973 20 3.96973 22 8.96973 22H14.9697C19.9697 22 21.9697 20 21.9697 15Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.96973 2V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14.9702 9.44043L12.4102 12.0004L14.9702 14.5604"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function MessageAddIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M9.38 18.4297H11.5L15.95 21.3997C16.61 21.8397 17.5 21.3597 17.5 20.5597V18.4297C19 18.4297 20.25 17.9297 21.12 17.0597C22 16.1797 22.5 14.9297 22.5 13.4297V7.42969C22.5 4.42969 20.5 2.42969 17.5 2.42969H7.5C4.5 2.42969 2.5 4.42969 2.5 7.42969V13.4297"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75821 16.8623H2.76367"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.26074 14.3652L5.26074 19.3598"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function MoneyIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 28 28">
      <path
        d="M19.8333 23.9167H8.16665C4.66665 23.9167 2.33331 22.1667 2.33331 18.0833V9.91668C2.33331 5.83334 4.66665 4.08334 8.16665 4.08334H19.8333C23.3333 4.08334 25.6666 5.83334 25.6666 9.91668V18.0833C25.6666 22.1667 23.3333 23.9167 19.8333 23.9167Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 17.5C15.933 17.5 17.5 15.933 17.5 14C17.5 12.067 15.933 10.5 14 10.5C12.067 10.5 10.5 12.067 10.5 14C10.5 15.933 12.067 17.5 14 17.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.91667 7H8.16667C6.55667 7 5.25 8.30667 5.25 9.91667V11.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0833 7H19.8333C21.4433 7 22.75 8.30667 22.75 9.91667V11.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.91667 21H8.16667C6.55667 21 5.25 19.6933 5.25 18.0833V16.3333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0833 21H19.8333C21.4433 21 22.75 19.6933 22.75 18.0833V16.3333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function WaveIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M1 7.33333V10.6667M4 4.83333V13.1667M7 1.5V16.5M10 7.33333V10.6667M13 4.83333V13.1667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function BreadCrumbRightArrowIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M8.90997 19.92L15.43 13.4C16.2 12.63 16.2 11.37 15.43 10.6L8.90997 4.08002"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function DangerIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path d="M12 9V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.0001 21.4103H5.94005C2.47005 21.4103 1.02005 18.9303 2.70005 15.9003L5.82006 10.2803L8.76006 5.00027C10.5401 1.79027 13.4601 1.79027 15.2401 5.00027L18.1801 10.2903L21.3001 15.9103C22.9801 18.9403 21.5201 21.4203 18.0601 21.4203H12.0001V21.4103Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9945 17H12.0035"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function CopyIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M16.5 12.9V17.1C16.5 20.6 15.1 22 11.6 22H7.4C3.9 22 2.5 20.6 2.5 17.1V12.9C2.5 9.4 3.9 8 7.4 8H11.6C15.1 8 16.5 9.4 16.5 12.9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 6.9V11.1C22.5 14.6 21.1 16 17.6 16H16.5V12.9C16.5 9.4 15.1 8 11.6 8H8.5V6.9C8.5 3.4 9.9 2 13.4 2H17.6C21.1 2 22.5 3.4 22.5 6.9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function TimerIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 43">
      <defs>
        <clipPath id="hourglass-clip">
          <path d="M26.67 4H15.33C8.75001 4 8.24251 9.915 11.795 13.135L30.205 29.865C33.7575 33.085 33.25 39 26.67 39H15.33C8.75001 39 8.24251 33.085 11.795 29.865L30.205 13.135C33.7575 9.915 33.25 4 26.67 4Z" />
        </clipPath>
        <clipPath id="top-sand-clip">
          <rect x="0" y="0" width="42" height="21.5">
            <animate attributeName="height" from="21.5" to="0" dur="2s" repeatCount="indefinite" />
          </rect>
        </clipPath>
        <clipPath id="bottom-sand-clip">
          <rect x="0" width="42" y="43" height="0">
            <animate attributeName="y" from="43" to="21.5" dur="2s" repeatCount="indefinite" />
            <animate attributeName="height" from="0" to="21.5" dur="2s" repeatCount="indefinite" />
          </rect>
        </clipPath>
      </defs>
      <path
        d="M26.67 4H15.33C8.75001 4 8.24251 9.915 11.795 13.135L30.205 29.865C33.7575 33.085 33.25 39 26.67 39H15.33C8.75001 39 8.24251 33.085 11.795 29.865L30.205 13.135C33.7575 9.915 33.25 4 26.67 4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#hourglass-clip)">
        <rect x="0" y="0" width="42" height="43" fill="black" clipPath="url(#top-sand-clip)" />
        <rect x="0" y="0" width="42" height="43" fill="black" clipPath="url(#bottom-sand-clip)" />
      </g>
    </SvgIconWrapper>
  );
}

export function FarmIconNew(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 43">
      <path
        d="M38.4998 26.8281V37.7441"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6904 29.463C24.3301 28.8186 26.0135 28.2987 27.7271 27.9076C30.9353 27.1798 34.2116 26.8179 37.4968 26.8283C37.8316 26.8283 38.165 26.8283 38.4998 26.8386"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0894 31.7216C31.8614 31.2153 34.6755 30.9633 37.4952 30.9688C37.8305 30.9688 38.1644 30.9688 38.4997 30.98"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0894 35.8622C31.4497 35.4177 33.8413 35.166 36.2412 35.1094"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.49316 25.6995V23.8174"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.49316 37.7445V25.6992"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.4997 37.7451H27.135H3.49316"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.49316 23.8174C16.2109 24.235 26.7477 30.0161 29.8421 37.7447"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75171 27.958C13.6385 29.3828 20.1831 32.9898 23.8196 37.7448"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.49316 32.0986C7.13838 32.9101 10.456 34.2021 13.2799 35.8628"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3367 11.8608C28.7444 11.3385 29.3023 10.9579 29.933 10.7716C30.5637 10.5853 31.236 10.6027 31.8566 10.8212C32.4772 11.0398 33.0152 11.4487 33.3962 11.9913C33.7772 12.5339 33.9823 13.1832 33.9829 13.8493V26.4529"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.2188 27.2058V17.8498L27.6777 13.7326L22.1266 10.6436L16.5741 13.7326L14.033 17.8498V25.5309"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.55 26.363V21.1826H25.7019V27.9581"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5684 17.761C24.2756 17.0538 24.2756 15.9071 23.5684 15.1999C22.8612 14.4927 21.7146 14.4927 21.0073 15.1999C20.3001 15.9071 20.3001 17.0538 21.0073 17.761C21.7145 18.4682 22.8612 18.4682 23.5684 17.761Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0328 17.7939L12.9036 19.676"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.2188 17.7939L31.7244 19.676"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.63379 5.75L8.0102 12.5255"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2801 14.0301L8.01025 12.5244"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.49316 15.1593L8.01013 12.5244"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.01025 12.5244V23.8168"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function FarmFieldIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 43">
      <path
        d="M38.5 23.2295V38.6141"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1155 27.0756C24.8217 26.0543 26.633 25.2336 28.5156 24.6289C31.4489 23.6922 34.5023 23.2205 37.572 23.2296C37.8823 23.2296 38.1912 23.2296 38.5001 23.2434"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 19C10.0561 19.2401 15.973 21.3317 20.3618 24.5972C21.5562 25.4818 22.6589 26.4845 23.6531 27.5903C26.4683 30.7336 28.1124 34.5294 28.1154 38.6154"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.5 21.6923V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3.5 38.6155V21.6924"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4231 19.801C15.9468 19.7787 16.4764 19.7676 17.0119 19.7676C23.0774 19.7676 28.4867 21.2711 31.9616 23.6137"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.8856 10.7462C35.2485 9.22269 34.3077 7.69339 32.7842 7.33044C31.2606 6.96748 29.7313 7.90831 29.3684 9.43184C29.0054 10.9554 29.9463 12.4847 31.4698 12.8476C32.9933 13.2106 34.5226 12.2697 34.8856 10.7462Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9614 5.53846V4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1923 5.92188L35.4231 6.69111"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.1154 10.1553H36.5769"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1923 14.3833L35.4231 13.2295"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9614 15.9224V14.7686"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8846 13.2295L27.7307 14.3833"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.7308 10.1553H26.1924"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8846 6.69111L27.7307 5.92188"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.5 38.6143H27.1357H3.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.4231 29.7674C26.8091 29.0294 28.2547 28.4181 29.7436 27.9404C31.7175 27.307 33.7498 26.8881 35.8077 26.6904"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.4231 35.5383C31.0367 35.289 31.6667 35.0616 32.3133 34.8561C34.3259 34.2155 36.4002 33.7995 38.5 33.6152"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5769 30.9238C9.34456 31.4241 11.8328 32.4306 13.8109 33.8777C14.396 34.3003 14.936 34.7803 15.4225 35.3103C16.1232 36.0782 16.9571 37.2737 16.9615 38.6161"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 22.8467C9.07332 23.0724 14.2512 24.7859 18.1997 27.7288C19.197 28.4678 20.1178 29.3049 20.9486 30.2278C22.7171 32.2012 23.8427 34.4047 24.2692 36.6928"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0161 11.2919C17.6137 11.2919 18.1867 11.0542 18.6093 10.6311C19.0318 10.208 19.2692 9.63423 19.2692 9.03591C19.2692 8.43758 19.0318 7.86375 18.6093 7.44067C18.1867 7.0176 17.6137 6.77992 17.0161 6.77992C16.8987 6.7795 16.7816 6.78864 16.6657 6.80725C16.5694 6.05076 16.2075 5.3532 15.6448 4.83929C15.0821 4.32537 14.3552 4.02858 13.594 4.00196C12.8328 3.97534 12.087 4.22062 11.4898 4.69398C10.8926 5.16733 10.483 5.8379 10.3343 6.58581C9.99842 6.39635 9.62364 6.28654 9.23877 6.26484C8.85389 6.24315 8.46917 6.31015 8.11422 6.46069C7.75926 6.61122 7.44352 6.84127 7.19129 7.13315C6.93906 7.42503 6.75706 7.77095 6.6593 8.14431C6.56154 8.51766 6.55061 8.90851 6.62737 9.28676C6.70413 9.665 6.86653 10.0206 7.10206 10.3261C7.3376 10.6316 7.63999 10.879 7.98599 11.0492C8.33199 11.2194 8.71236 11.3078 9.09785 11.3077L17.0161 11.2919Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ReceiptIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 43">
      <path
        d="M11.7775 34.475C13.2125 32.935 15.4 33.0575 16.66 34.7375L18.4275 37.1C19.845 38.9725 22.1375 38.9725 23.555 37.1L25.3225 34.7375C26.5825 33.0575 28.77 32.935 30.205 34.475C33.32 37.8 35.8575 36.6975 35.8575 32.0425V12.32C35.875 5.2675 34.23 3.5 27.615 3.5H14.385C7.77 3.5 6.125 5.2675 6.125 12.32V32.025C6.125 36.6975 8.68 37.7825 11.7775 34.475Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1681 19.25H14.1838"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0723 19.25H28.6973"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1681 12.25H14.1838"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0723 12.25H28.6973"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ChartIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 42">
      <path
        d="M15.75 38.5H26.25C35 38.5 38.5 35 38.5 26.25V15.75C38.5 7 35 3.5 26.25 3.5H15.75C7 3.5 3.5 7 3.5 15.75V26.25C3.5 35 7 38.5 15.75 38.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.125 32.375C29.05 32.375 30.625 30.8 30.625 28.875V13.125C30.625 11.2 29.05 9.625 27.125 9.625C25.2 9.625 23.625 11.2 23.625 13.125V28.875C23.625 30.8 25.1825 32.375 27.125 32.375Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.875 32.375C16.8 32.375 18.375 30.8 18.375 28.875V22.75C18.375 20.825 16.8 19.25 14.875 19.25C12.95 19.25 11.375 20.825 11.375 22.75V28.875C11.375 30.8 12.9325 32.375 14.875 32.375Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function CalendarIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 43">
      <path d="M14 3.5V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M28 3.5V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.125 15.9072H35.875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.75 14.875V29.75C36.75 35 34.125 38.5 28 38.5H14C7.875 38.5 5.25 35 5.25 29.75V14.875C5.25 9.625 7.875 6.125 14 6.125H28C34.125 6.125 36.75 9.625 36.75 14.875Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9921 23.9746H21.0078"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.515 23.9746H14.5308"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.515 29.2246H14.5308"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function BoxIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 43">
      <path
        d="M5.54761 13.0195L21.0001 21.962L36.3476 13.072"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 37.8168V21.9443"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3776 4.34L8.03259 9.53756C5.91509 10.7101 4.18262 13.65 4.18262 16.065V25.9526C4.18262 28.3676 5.91509 31.3075 8.03259 32.48L17.3776 37.6776C19.3726 38.7801 22.6451 38.7801 24.6401 37.6776L33.9851 32.48C36.1026 31.3075 37.8351 28.3676 37.8351 25.9526V16.065C37.8351 13.65 36.1026 10.7101 33.9851 9.53756L24.6401 4.34C22.6276 3.22 19.3726 3.22 17.3776 4.34Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.7501 23.1698V16.7649L13.1426 7.1748"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function NoteIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 43">
      <path
        d="M35 14.9375V32C35 37.25 31.8675 39 28 39H14C10.1325 39 7 37.25 7 32V14.9375C7 9.25 10.1325 7.9375 14 7.9375C14 9.0225 14.4375 10.0025 15.155 10.72C15.8725 11.4375 16.8525 11.875 17.9375 11.875H24.0625C26.2325 11.875 28 10.1075 28 7.9375C31.8675 7.9375 35 9.25 35 14.9375Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 7.9375C28 10.1075 26.2325 11.875 24.0625 11.875H17.9375C16.8525 11.875 15.8725 11.4375 15.155 10.72C14.4375 10.0025 14 9.0225 14 7.9375C14 5.7675 15.7675 4 17.9375 4H24.0625C25.1475 4 26.1275 4.43751 26.845 5.15501C27.5625 5.87251 28 6.8525 28 7.9375Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14 23.25H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 30.25H28" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIconWrapper>
  );
}

export function ExcelIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 42">
      <path
        d="M25 4V11.7778C25 12.2935 25.2107 12.7881 25.5858 13.1527C25.9609 13.5174 26.4696 13.7222 27 13.7222H35"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 39H11C9.93913 39 8.92172 38.5903 8.17157 37.861C7.42143 37.1317 7 36.1425 7 35.1111V7.88889C7 6.85749 7.42143 5.86834 8.17157 5.13903C8.92172 4.40972 9.93913 4 11 4H25L35 13.7222V35.1111C35 36.1425 34.5786 37.1317 33.8284 37.861C33.0783 38.5903 32.0609 39 31 39Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 19.75L26.25 32M15.75 32L26.25 19.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function PdfIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 42">
      <path
        d="M25 4V11.7778C25 12.2935 25.2107 12.7881 25.5858 13.1527C25.9609 13.5174 26.4696 13.7222 27 13.7222H35"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 39H11C9.93913 39 8.92172 38.5903 8.17157 37.861C7.42143 37.1317 7 36.1425 7 35.1111V7.88889C7 6.85749 7.42143 5.86834 8.17157 5.13903C8.92172 4.40972 9.93913 4 11 4H25L35 13.7222V35.1111C35 36.1425 34.5786 37.1317 33.8284 37.861C33.0783 38.5903 32.0609 39 31 39Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0096 16.2791C13.9876 17.1422 26.585 31.7907 27.9279 28.4396C29.2708 25.0885 11.3812 29.4087 14.3285 31.7907C17.2759 34.1728 20.0294 15.4137 17.0096 16.2791Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function DownloadIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 42 42">
      <path
        d="M16.4405 8.90039C20.0405 9.21039 21.5105 11.0604 21.5105 15.1104V15.2404C21.5105 19.7104 19.7205 21.5004 15.2505 21.5004H8.74047C4.27047 21.5004 2.48047 19.7104 2.48047 15.2404V15.1104C2.48047 11.0904 3.93047 9.24039 7.47047 8.91039"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 2V14.88" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15.3504 12.6504L12.0004 16.0004L8.65039 12.6504"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ArrowForwardIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M14.4299 5.92969L20.4999 11.9997L14.4299 18.0697"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 12H20.33"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function TickCircle(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M1.33301 8.00065L5.77222 12.6673L14.6663 3.33398"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function SunIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 15.5899 8.41015 18.5 12 18.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.14 19.14L19.01 19.01M19.01 4.99L19.14 4.86L19.01 4.99ZM4.86 19.14L4.99 19.01L4.86 19.14ZM12 2.08V2V2.08ZM12 22V21.92V22ZM2.08 12H2H2.08ZM22 12H21.92H22ZM4.99 4.99L4.86 4.86L4.99 4.99Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function CloudyIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M16.61 20C17.95 20.01 19.24 19.51 20.23 18.61C23.5 15.75 21.75 10.01 17.44 9.47001C15.9 0.13001 2.42998 3.67001 5.61998 12.56"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.27999 12.97C6.74999 12.7 6.15999 12.56 5.56999 12.57C0.909986 12.9 0.919986 19.68 5.56999 20.01"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.82 9.88998C16.34 9.62998 16.9 9.48998 17.48 9.47998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.96997 20L7.96997 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.97 20L11.97 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.97 16L11.97 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.96997 16L7.96997 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function MenuIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path d="M3 7H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M3 12H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M3 17H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIconWrapper>
  );
}
export function TilleyLogoIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 62 62">
      <path
        d="M47.895 47.9274C47.74 48.5904 47.1071 49.0813 46.2869 49.1631C41.5077 49.6432 30.9548 51.4902 21.7258 58.4652C21.3965 58.715 20.9681 58.7925 20.572 58.6762C19.797 58.4502 19.4052 57.5847 19.7539 56.8571C21.3793 53.46 26.1498 48.0587 34.3217 45.1934L33.0559 44.4076C32.6447 44.1514 32.6275 43.7984 32.6426 43.6627C32.6899 43.0987 33.353 42.8447 33.5726 42.7586C34.9417 42.2247 36.3518 41.736 37.7727 41.3119C38.2872 41.1547 38.8577 41.2258 39.299 41.5013C40.7607 42.4055 44.7692 44.892 47.1889 46.3925C47.7572 46.7541 48.0349 47.3397 47.8972 47.9252L47.895 47.9274Z"
        fill="currentColor"
      />
      <path
        d="M10.8758 18.7248C16.1824 12.1911 21.545 9.47218 24.2704 8.44315C24.6558 8.29461 25.1401 8.34197 25.4846 8.54864L40.0137 17.5322C40.0137 17.5322 39.9943 17.5623 39.919 17.5925C25.4178 23.0885 19.9606 31.0667 18.0015 35.327C17.7884 35.7834 17.9499 36.2829 18.389 36.567C18.5612 36.6747 18.7615 36.7457 18.9746 36.7694C19.3793 36.8146 19.8099 36.6962 20.1048 36.3453C30.098 24.4318 45.471 21.5127 51.615 20.8087C52.4115 20.7226 53.0121 20.2382 53.165 19.5902C53.2942 19.0111 53.0229 18.4342 52.4632 18.0833L29.7987 3.9869C28.6599 3.28079 27.1271 3.08058 25.7774 3.45732C14.9037 6.53579 10.5185 13.7691 8.87159 17.8077C8.69291 18.2447 8.85868 18.7054 9.28493 18.9616C9.75208 19.2307 10.4668 19.2156 10.8758 18.7184V18.727V18.7248Z"
        fill="currentColor"
      />
      <path
        d="M15.7971 49.4277C15.6012 49.8777 15.7691 50.3706 16.2126 50.6376C16.3783 50.7366 16.5699 50.8077 16.7766 50.8292C17.1813 50.8744 17.6183 50.756 17.9154 50.4051C28.1669 38.1364 43.2515 35.482 49.2663 34.9159C50.0284 34.8427 50.6183 34.3884 50.769 33.7641C50.896 33.2087 50.6462 32.6597 50.1081 32.3175C47.8455 30.9052 44.0243 28.5372 42.3085 27.4759L41.9856 27.2778C41.5443 27.0022 40.9824 26.9398 40.4679 27.0884C39.0471 27.5125 37.637 28.0011 36.2678 28.535C36.0504 28.6233 35.3874 28.8752 35.3378 29.4392C35.3228 29.5748 35.3379 29.9279 35.7512 30.1841L37.017 30.9698C23.3749 35.7468 17.8702 44.5754 15.8035 49.4256H15.7949L15.7971 49.4277Z"
        fill="currentColor"
      />
    </SvgIconWrapper>
  );
}

export function RedoIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M16.87 5.69H8.87C6.11 5.69 3.87 7.93 3.87 10.69C3.87 13.45 6.11 15.69 8.87 15.69H19.87"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5699 13.19L20.1299 15.75L17.5699 18.31"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function AddNoteIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.56006 18V13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15.5H6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function EditNoteIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.04 3.02123L8.16 10.9012C7.86 11.2012 7.56 11.7912 7.5 12.2212L7.07 15.2312C6.91 16.3212 7.68 17.0812 8.77 16.9312L11.78 16.5012C12.2 16.4412 12.79 16.1412 13.1 15.8412L20.98 7.96123C22.34 6.60123 22.98 5.02123 20.98 3.02123C18.98 1.02123 17.4 1.66123 16.04 3.02123Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.91 4.14844C15.58 6.53844 17.45 8.40844 19.85 9.08844"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function SaveIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M19.54 6.53998L16.47 3.46997C15.53 2.52997 14.26 2.01001 12.93 2.01001H8C5 2.01001 3 4.01001 3 7.01001V17.01C3 20.01 5 22.01 8 22.01H16C19 22.01 21 20.01 21 17.01V10.08C21 8.74002 20.47 7.46998 19.54 6.53998Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 22V16C17 14.8954 16.1046 14 15 14H9C7.89543 14 7 14.8954 7 16V22"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M7 2L7 4C7 5.10457 7.89543 6 9 6L12 6C13.1046 6 14 5.10457 14 4L14 2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M10 17H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIconWrapper>
  );
}

export function SuccessIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function ErrorIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16992 14.8319L14.8299 9.17188"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8299 14.8319L9.16992 9.17188"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function SettingsIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M20.8067 7.62358L20.1842 6.54349C19.6577 5.62957 18.4907 5.31429 17.5755 5.83869V5.83869C17.1399 6.09531 16.6201 6.16812 16.1307 6.04106C15.6413 5.91399 15.2226 5.59749 14.9668 5.16134C14.8023 4.88412 14.7139 4.56836 14.7105 4.24601V4.24601C14.7254 3.72919 14.5304 3.22837 14.17 2.85764C13.8096 2.48691 13.3145 2.27783 12.7975 2.27805H11.5435C11.037 2.27804 10.5513 2.47988 10.194 2.83891C9.83669 3.19795 9.63717 3.68456 9.63961 4.19109V4.19109C9.6246 5.23689 8.77248 6.07678 7.72657 6.07667C7.40421 6.07332 7.08846 5.98491 6.81123 5.82038V5.82038C5.89606 5.29598 4.72911 5.61126 4.20254 6.52519L3.53435 7.62358C3.00841 8.53636 3.3194 9.70258 4.23 10.2323V10.2323C4.8219 10.574 5.18653 11.2056 5.18653 11.889C5.18653 12.5725 4.8219 13.204 4.23 13.5458V13.5458C3.32056 14.0719 3.00923 15.2353 3.53435 16.1453V16.1453L4.16593 17.2346C4.41265 17.6798 4.8266 18.0083 5.31619 18.1474C5.80578 18.2866 6.33064 18.2249 6.77462 17.976V17.976C7.21108 17.7213 7.73119 17.6515 8.21934 17.7822C8.70749 17.9128 9.12324 18.233 9.37416 18.6716C9.5387 18.9489 9.62711 19.2646 9.63046 19.587V19.587C9.63046 20.6435 10.487 21.5 11.5435 21.5H12.7975C13.8505 21.5 14.7055 20.6491 14.7105 19.5961V19.5961C14.7081 19.088 14.9089 18.6 15.2682 18.2407C15.6275 17.8814 16.1155 17.6806 16.6236 17.6831C16.9452 17.6917 17.2596 17.7797 17.5389 17.9394V17.9394C18.4517 18.4653 19.6179 18.1543 20.1476 17.2437V17.2437L20.8067 16.1453C21.0618 15.7075 21.1318 15.186 21.0012 14.6963C20.8706 14.2067 20.5502 13.7893 20.111 13.5366V13.5366C19.6718 13.2839 19.3514 12.8665 19.2208 12.3769C19.0902 11.8873 19.1603 11.3658 19.4154 10.9279C19.5812 10.6383 19.8214 10.3982 20.111 10.2323V10.2323C21.0161 9.70286 21.3264 8.54346 20.8067 7.63274V7.63274V7.62358Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12.1751"
        cy="11.889"
        r="2.63616"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function AddCircleIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 12H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 16V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIconWrapper>
  );
}

export function TickCircleIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 12L10.58 14.83L16.25 9.16998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function VisibilityOffIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M14.53 9.47004L9.47004 14.53C8.82004 13.88 8.42004 12.99 8.42004 12C8.42004 10.02 10.02 8.42004 12 8.42004C12.99 8.42004 13.88 8.82004 14.53 9.47004Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.82 5.76998C16.07 4.44998 14.07 3.72998 12 3.72998C8.46997 3.72998 5.17997 5.80998 2.88997 9.40998C1.98997 10.82 1.98997 13.19 2.88997 14.6C3.67997 15.84 4.59997 16.91 5.59997 17.77"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.42004 19.5301C9.56004 20.0101 10.77 20.2701 12 20.2701C15.53 20.2701 18.82 18.1901 21.11 14.5901C22.01 13.1801 22.01 10.8101 21.11 9.40005C20.78 8.88005 20.42 8.39005 20.05 7.93005"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.47 14.53L2 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 2L14.53 9.47" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIconWrapper>
  );
}

export function LightModeIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 15.5899 8.41015 18.5 12 18.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.14 19.14L19.01 19.01M19.01 4.99L19.14 4.86L19.01 4.99ZM4.86 19.14L4.99 19.01L4.86 19.14ZM12 2.08V2V2.08ZM12 22V21.92V22ZM2.08 12H2H2.08ZM22 12H21.92H22ZM4.99 4.99L4.86 4.86L4.99 4.99Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}

export function DarkModeIcon(props) {
  return (
    <SvgIconWrapper {...props} viewBox="0 0 24 24">
      <path
        d="M2.03 12.42C2.39 17.57 6.76 21.76 11.99 21.99C15.68 22.15 18.98 20.43 20.96 17.72C21.78 16.61 21.34 15.87 19.97 16.12C19.3 16.24 18.61 16.29 17.89 16.26C13 16.06 9 11.97 8.98 7.14002C8.97 5.84002 9.24 4.61002 9.73 3.49002C10.27 2.25002 9.62 1.66002 8.37 2.19002C4.41 3.86002 1.7 7.85002 2.03 12.42Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconWrapper>
  );
}
